(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Map = {}));
}(this, (function (exports) { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c),
        u = i.value;
    } catch (n) {
      return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator(n) {
    return function () {
      var t = this,
        e = arguments;
      return new Promise(function (r, o) {
        var a = n.apply(t, e);
        function _next(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  }
  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }
  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && _setPrototypeOf(t, e);
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function () {
      return !!t;
    })();
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
  }
  function _regeneratorRuntime() {
    _regeneratorRuntime = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }
    try {
      define({}, "");
    } catch (t) {
      define = function (t, e, r) {
        return t[e] = r;
      };
    }
    function wrap(t, e, r, n) {
      var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
      return o(a, "_invoke", {
        value: makeInvokeMethod(t, r, c)
      }), a;
    }
    function tryCatch(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    e.wrap = wrap;
    var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function () {
      return this;
    });
    var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
      ["next", "throw", "return"].forEach(function (e) {
        define(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function AsyncIterator(t, e) {
      function invoke(r, o, i, a) {
        var c = tryCatch(t[r], t, o);
        if ("throw" !== c.type) {
          var u = c.arg,
            h = u.value;
          return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
            invoke("next", t, i, a);
          }, function (t) {
            invoke("throw", t, i, a);
          }) : e.resolve(h).then(function (t) {
            u.value = t, i(u);
          }, function (t) {
            return invoke("throw", t, i, a);
          });
        }
        a(c.arg);
      }
      var r;
      o(this, "_invoke", {
        value: function (t, n) {
          function callInvokeWithMethodAndArg() {
            return new e(function (e, r) {
              invoke(t, n, e, r);
            });
          }
          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === f) throw Error("Generator is already running");
        if (o === s) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var c = n.delegate;
          if (c) {
            var u = maybeInvokeDelegate(c, n);
            if (u) {
              if (u === y) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (o === h) throw o = s, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = f;
          var p = tryCatch(e, r, n);
          if ("normal" === p.type) {
            if (o = n.done ? s : l, p.arg === y) continue;
            return {
              value: p.arg,
              done: n.done
            };
          }
          "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
        }
      };
    }
    function maybeInvokeDelegate(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
      var i = tryCatch(o, e.iterator, r.arg);
      if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
      var a = i.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
      if (e || "" === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function next() {
              for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              return next.value = t, next.done = !0, next;
            };
          return i.next = i;
        }
      }
      throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function (t) {
      return {
        __await: t
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(wrap(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
      return this;
    }), define(g, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (t) {
      var e = Object(t),
        r = [];
      for (var n in e) r.push(n);
      return r.reverse(), function next() {
        for (; r.length;) {
          var t = r.pop();
          if (t in e) return next.value = t, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, e.values = values, Context.prototype = {
      constructor: Context,
      reset: function (e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function () {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function (e) {
        if (this.done) throw e;
        var r = this;
        function handle(n, o) {
          return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i.completion;
          if ("root" === i.tryLoc) return handle("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            } else {
              if (!u) throw Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function (t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
      },
      complete: function (t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function (t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
        }
      },
      catch: function (t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.tryLoc === t) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              resetTryEntry(r);
            }
            return o;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function (e, r, n) {
        return this.delegate = {
          iterator: values(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }

  function noop() { }
  function run(fn) {
      return fn();
  }
  function blank_object() {
      return Object.create(null);
  }
  function run_all(fns) {
      fns.forEach(run);
  }
  function is_function(thing) {
      return typeof thing === 'function';
  }
  function safe_not_equal(a, b) {
      return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
  }
  function is_empty(obj) {
      return Object.keys(obj).length === 0;
  }

  function append(target, node) {
      target.appendChild(node);
  }
  function insert(target, node, anchor) {
      target.insertBefore(node, anchor || null);
  }
  function detach(node) {
      node.parentNode.removeChild(node);
  }
  function element(name) {
      return document.createElement(name);
  }
  function svg_element(name) {
      return document.createElementNS('http://www.w3.org/2000/svg', name);
  }
  function text(data) {
      return document.createTextNode(data);
  }
  function space() {
      return text(' ');
  }
  function attr(node, attribute, value) {
      if (value == null)
          node.removeAttribute(attribute);
      else if (node.getAttribute(attribute) !== value)
          node.setAttribute(attribute, value);
  }
  function children(element) {
      return Array.from(element.childNodes);
  }
  function toggle_class(element, name, toggle) {
      element.classList[toggle ? 'add' : 'remove'](name);
  }
  function custom_event(type, detail) {
      const e = document.createEvent('CustomEvent');
      e.initCustomEvent(type, false, false, detail);
      return e;
  }

  let current_component;
  function set_current_component(component) {
      current_component = component;
  }
  function get_current_component() {
      if (!current_component)
          throw new Error('Function called outside component initialization');
      return current_component;
  }
  function beforeUpdate(fn) {
      get_current_component().$$.before_update.push(fn);
  }
  function onMount(fn) {
      get_current_component().$$.on_mount.push(fn);
  }
  function onDestroy(fn) {
      get_current_component().$$.on_destroy.push(fn);
  }
  function createEventDispatcher() {
      const component = get_current_component();
      return (type, detail) => {
          const callbacks = component.$$.callbacks[type];
          if (callbacks) {
              // TODO are there situations where events could be dispatched
              // in a server (non-DOM) environment?
              const event = custom_event(type, detail);
              callbacks.slice().forEach(fn => {
                  fn.call(component, event);
              });
          }
      };
  }

  const dirty_components = [];
  const binding_callbacks = [];
  const render_callbacks = [];
  const flush_callbacks = [];
  const resolved_promise = Promise.resolve();
  let update_scheduled = false;
  function schedule_update() {
      if (!update_scheduled) {
          update_scheduled = true;
          resolved_promise.then(flush);
      }
  }
  function add_render_callback(fn) {
      render_callbacks.push(fn);
  }
  let flushing = false;
  const seen_callbacks = new Set();
  function flush() {
      if (flushing)
          return;
      flushing = true;
      do {
          // first, call beforeUpdate functions
          // and update components
          for (let i = 0; i < dirty_components.length; i += 1) {
              const component = dirty_components[i];
              set_current_component(component);
              update(component.$$);
          }
          set_current_component(null);
          dirty_components.length = 0;
          while (binding_callbacks.length)
              binding_callbacks.pop()();
          // then, once components are updated, call
          // afterUpdate functions. This may cause
          // subsequent updates...
          for (let i = 0; i < render_callbacks.length; i += 1) {
              const callback = render_callbacks[i];
              if (!seen_callbacks.has(callback)) {
                  // ...so guard against infinite loops
                  seen_callbacks.add(callback);
                  callback();
              }
          }
          render_callbacks.length = 0;
      } while (dirty_components.length);
      while (flush_callbacks.length) {
          flush_callbacks.pop()();
      }
      update_scheduled = false;
      flushing = false;
      seen_callbacks.clear();
  }
  function update($$) {
      if ($$.fragment !== null) {
          $$.update();
          run_all($$.before_update);
          const dirty = $$.dirty;
          $$.dirty = [-1];
          $$.fragment && $$.fragment.p($$.ctx, dirty);
          $$.after_update.forEach(add_render_callback);
      }
  }
  const outroing = new Set();
  let outros;
  function group_outros() {
      outros = {
          r: 0,
          c: [],
          p: outros // parent group
      };
  }
  function check_outros() {
      if (!outros.r) {
          run_all(outros.c);
      }
      outros = outros.p;
  }
  function transition_in(block, local) {
      if (block && block.i) {
          outroing.delete(block);
          block.i(local);
      }
  }
  function transition_out(block, local, detach, callback) {
      if (block && block.o) {
          if (outroing.has(block))
              return;
          outroing.add(block);
          outros.c.push(() => {
              outroing.delete(block);
              if (callback) {
                  if (detach)
                      block.d(1);
                  callback();
              }
          });
          block.o(local);
      }
  }
  function create_component(block) {
      block && block.c();
  }
  function mount_component(component, target, anchor, customElement) {
      const { fragment, on_mount, on_destroy, after_update } = component.$$;
      fragment && fragment.m(target, anchor);
      if (!customElement) {
          // onMount happens before the initial afterUpdate
          add_render_callback(() => {
              const new_on_destroy = on_mount.map(run).filter(is_function);
              if (on_destroy) {
                  on_destroy.push(...new_on_destroy);
              }
              else {
                  // Edge case - component was destroyed immediately,
                  // most likely as a result of a binding initialising
                  run_all(new_on_destroy);
              }
              component.$$.on_mount = [];
          });
      }
      after_update.forEach(add_render_callback);
  }
  function destroy_component(component, detaching) {
      const $$ = component.$$;
      if ($$.fragment !== null) {
          run_all($$.on_destroy);
          $$.fragment && $$.fragment.d(detaching);
          // TODO null out other refs, including component.$$ (but need to
          // preserve final state?)
          $$.on_destroy = $$.fragment = null;
          $$.ctx = [];
      }
  }
  function make_dirty(component, i) {
      if (component.$$.dirty[0] === -1) {
          dirty_components.push(component);
          schedule_update();
          component.$$.dirty.fill(0);
      }
      component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
  }
  function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
      const parent_component = current_component;
      set_current_component(component);
      const $$ = component.$$ = {
          fragment: null,
          ctx: null,
          // state
          props,
          update: noop,
          not_equal,
          bound: blank_object(),
          // lifecycle
          on_mount: [],
          on_destroy: [],
          on_disconnect: [],
          before_update: [],
          after_update: [],
          context: new Map(parent_component ? parent_component.$$.context : options.context || []),
          // everything else
          callbacks: blank_object(),
          dirty,
          skip_bound: false
      };
      let ready = false;
      $$.ctx = instance
          ? instance(component, options.props || {}, (i, ret, ...rest) => {
              const value = rest.length ? rest[0] : ret;
              if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                  if (!$$.skip_bound && $$.bound[i])
                      $$.bound[i](value);
                  if (ready)
                      make_dirty(component, i);
              }
              return ret;
          })
          : [];
      $$.update();
      ready = true;
      run_all($$.before_update);
      // `false` as a special case of no DOM component
      $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
      if (options.target) {
          if (options.hydrate) {
              const nodes = children(options.target);
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              $$.fragment && $$.fragment.l(nodes);
              nodes.forEach(detach);
          }
          else {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              $$.fragment && $$.fragment.c();
          }
          if (options.intro)
              transition_in(component.$$.fragment);
          mount_component(component, options.target, options.anchor, options.customElement);
          flush();
      }
      set_current_component(parent_component);
  }
  /**
   * Base class for Svelte components. Used when dev=false.
   */
  class SvelteComponent {
      $destroy() {
          destroy_component(this, 1);
          this.$destroy = noop;
      }
      $on(type, callback) {
          const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
          callbacks.push(callback);
          return () => {
              const index = callbacks.indexOf(callback);
              if (index !== -1)
                  callbacks.splice(index, 1);
          };
      }
      $set($$props) {
          if (this.$$set && !is_empty($$props)) {
              this.$$.skip_bound = true;
              this.$$set($$props);
              this.$$.skip_bound = false;
          }
      }
  }

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  		path: basedir,
  		exports: {},
  		require: function (path, base) {
  			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
  		}
  	}, fn(module, module.exports), module.exports;
  }

  function getAugmentedNamespace(n) {
  	if (n.__esModule) return n;
  	var a = Object.defineProperty({}, '__esModule', {value: true});
  	Object.keys(n).forEach(function (k) {
  		var d = Object.getOwnPropertyDescriptor(n, k);
  		Object.defineProperty(a, k, d.get ? d : {
  			enumerable: true,
  			get: function () {
  				return n[k];
  			}
  		});
  	});
  	return a;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise */

  var extendStatics = function(d, b) {
      extendStatics = Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
          function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
      return extendStatics(d, b);
  };

  function __extends(d, b) {
      extendStatics(d, b);
      function __() { this.constructor = d; }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                  t[p[i]] = s[p[i]];
          }
      return t;
  }

  function __decorate(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
      else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  }

  function __param(paramIndex, decorator) {
      return function (target, key) { decorator(target, key, paramIndex); }
  }

  function __metadata(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
  }

  function __awaiter$1(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  var __createBinding = Object.create ? (function(o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
  }) : (function(o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      o[k2] = m[k];
  });

  function __exportStar(m, o) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
  }

  function __values(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
          next: function () {
              if (o && i >= o.length) o = void 0;
              return { value: o && o[i++], done: !o };
          }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  function __spread() {
      for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read(arguments[i]));
      return ar;
  }

  function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
      return r;
  }
  function __await(v) {
      return this instanceof __await ? (this.v = v, this) : new __await(v);
  }

  function __asyncGenerator(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = generator.apply(thisArg, _arguments || []), i, q = [];
      return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
      function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
      function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
      function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
      function fulfill(value) { resume("next", value); }
      function reject(value) { resume("throw", value); }
      function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
  }

  function __asyncDelegator(o) {
      var i, p;
      return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
      function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
  }

  function __asyncValues(o) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var m = o[Symbol.asyncIterator], i;
      return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
      function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
      function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
  }

  function __makeTemplateObject(cooked, raw) {
      if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
      return cooked;
  }
  var __setModuleDefault = Object.create ? (function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
  }) : function(o, v) {
      o["default"] = v;
  };

  function __importStar(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
      __setModuleDefault(result, mod);
      return result;
  }

  function __importDefault(mod) {
      return (mod && mod.__esModule) ? mod : { default: mod };
  }

  function __classPrivateFieldGet(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
  }

  function __classPrivateFieldSet(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
  }

  var tslib_es6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    __extends: __extends,
    get __assign () { return __assign; },
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter$1,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet
  });

  var Cache_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  /**
   * Simple cache implementation
   */
  var Cache = /** @class */ (function () {
      function Cache() {
          this.data = {};
          this.pending = {};
      }
      Cache.prototype.put = function (key, value) {
          var previousValue = this.data[key];
          this.data[key] = value;
          return previousValue;
      };
      Cache.prototype.get = function (key) {
          return this.data[key];
      };
      Cache.prototype.remove = function (key) {
          var previousValue = this.data[key];
          delete this.data[key];
          return previousValue;
      };
      Cache.prototype.removeAll = function () {
          this.data = {};
      };
      /**
       * Gets a value from the cache or invokes the callback to populate the value
       * with the result of a promise. If invoked multiple times, it will return the promise
       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
       *
       * @param key cache key
       * @param callback returns a Promise to populate the cache with
       * @returns Promise<*> a promise with the cached value
       */
      Cache.prototype.refreshIfAbsent = function (key, callback) {
          if (this.data.hasOwnProperty(key)) {
              return Promise.resolve(this.data[key]);
          }
          return this.refresh(key, callback);
      };
      /**
       * Invokes the callback to populate the value with the result of a promise.
       * If invoked multiple times, it will return the promise
       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
       *
       * @param key cache key
       * @param callback returns a Promise to populate the cache with
       * @returns Promise<*> a promise with the cached value
       */
      Cache.prototype.refresh = function (key, callback) {
          var _this = this;
          // Check if the callback is already pending for this key
          var pending = this.pending[key];
          if (pending) {
              return pending;
          }
          pending = callback();
          this.pending[key] = pending;
          return pending.then(function (value) {
              delete _this.pending[key];
              _this.put(key, value);
              return value;
          }).catch(function (error) {
              delete _this.pending[key];
              throw error;
          });
      };
      return Cache;
  }());
  exports.default = Cache;

  });

  var tslib_1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

  var Registry_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.SERVICE_REGISTRY_PATH = void 0;

  var Cache_1$1 = tslib_1.__importDefault(Cache_1);
  exports.SERVICE_REGISTRY_PATH = '/api/portal/v2/client/config';
  var PORTAL_SERVICE_NAME = 'portal_service';
  var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
  var DEFAULT_CONFIG = {
      host: '',
      cache: new Cache_1$1.default(),
  };
  var Registry = /** @class */ (function () {
      function Registry(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
      }
      // Get the underlying registry cache
      Registry.prototype.getCache = function () {
          return this.config.cache;
      };
      Registry.prototype.getRegistry = function () {
          var _this = this;
          return this.config.cache.refreshIfAbsent('registry', function () {
              var serviceRegistryUrl = _this.getHost();
              serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
              var config = {
                  method: 'GET',
                  mode: 'cors',
                  credentials: 'include',
                  headers: {
                      'Content-Type': 'application/json',
                  },
              };
              return fetch(serviceRegistryUrl, config).then(function (resp) {
                  if (!resp.ok) {
                      return Promise.reject(resp);
                  }
                  return resp.json().then(function (data) {
                      var dataResponse = tslib_1.__assign({ data: data }, resp);
                      var registry = data.registry;
                      // Optimization - also stuff the client config URL into the cache.
                      // Sometimes, this URL can be different if it's requested from the same domain.
                      var portalService = registry.services[PORTAL_SERVICE_NAME];
                      if (portalService) {
                          var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH, 2);
                          _this.config.cache.put(clientConfigUrl, dataResponse);
                      }
                      return dataResponse;
                  });
              });
          }).then(function (resp) {
              return resp.data.registry;
          });
      };
      Registry.prototype.getUrl = function (serviceName, path, version) {
          var _this = this;
          if (path === void 0) { path = ''; }
          return this.getRegistry().then(function (data) {
              var service = data.services[serviceName];
              if (service === undefined) {
                  throw new Error("Unable to find service '" + serviceName + "'");
              }
              return service;
          }).then(function (service) {
              return _this.createServiceUrl(service, path, version);
          });
      };
      Registry.prototype.getServiceBaseUrl = function (service, version) {
          var baseUrl = service.base_sv_url;
          if (!baseUrl) {
              // unversioned service - simply return regular service url
              return service.sv_url;
          }
          if (version === undefined) {
              // Use configured version if present
              // if(apiVersions[serviceName]) {
              //  version = apiVersions[serviceName];
              // Fallback to version 1 (keeps backwards comparability and generally safe)
              version = 1;
          }
          return this.joinUrlParts(baseUrl, 'v' + version);
      };
      Registry.prototype.getServiceHostUrl = function (service) {
          // Inspired by https://gist.github.com/jlong/2428561
          var parser = document.createElement('a');
          parser.href = service.sv_url;
          return parser.protocol + "//" + parser.host;
      };
      Registry.prototype.createServiceUrl = function (service, path, version) {
          var base;
          if (path.charAt(0) === '/') {
              // Host absolute URL
              base = this.getServiceHostUrl(service);
          }
          else {
              // Service relative URL
              base = this.getServiceBaseUrl(service, version);
          }
          return this.joinUrlParts(base, path);
      };
      /**
       * Determines the registry host in the following order,
       * 1. Uses the configured host if set
       * 2. If a PrintOS subdomain is detected as the current hostname,
       *    the base domain is returned.
       *    For example, if location.hostname is 'app.www.printos.com',
       *    then 'www.printos.com' is returned.
       * 3. Return an empty string otherwise (resulting in a registry call relative
       *    to the current host).
       */
      Registry.prototype.getHost = function () {
          if (this.config.host) {
              // Ensure https
              if (this.config.host.indexOf('https://') !== 0) {
                  this.config.host = 'https://' + this.config.host;
              }
              return this.config.host;
          }
          return '';
      };
      Registry.prototype.joinUrlParts = function (a, b) {
          if (!b) {
              return a;
          }
          if (b.charAt(0) === '/') {
              // Prevent double slashes by ensuring part b doesn't have a slash
              b = b.substr(1);
          }
          if (a.charAt(a.length - 1) === '/') {
              return a + b;
          }
          return a + '/' + b;
      };
      return Registry;
  }());
  exports.default = Registry;

  });

  var Http_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Registry_1$1 = tslib_1.__importDefault(Registry_1);
  var DEFAULT_CONFIG = {
      registry: new Registry_1$1.default(),
  };
  var Http = /** @class */ (function () {
      function Http(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
          // Use registry cache by default to cache the registry efficiently
          // Use registry cache by default to cache the registry efficiently
          this.config.cache = this.config.cache || this.config.registry.getCache();
      }
      Http.prototype.getCookie = function (name) {
          var value = "; " + document.cookie;
          var parts = value.split("; " + name + "=");
          if (parts.length == 2) {
              return decodeURIComponent(parts.pop().split(';').shift());
          }
      };
      Http.prototype.fetchJsonResponse = function (config) {
          var _this = this;
          var url = Http.formatUrl(config);
          var fetchConfig = {
              method: config.method,
              mode: config.mode ? config.mode : 'cors',
              credentials: config.credentials ? config.credentials : 'include',
              headers: {},
          };
          // if (fetchConfig.credentials === 'include') {
          //   fetchConfig.headers['Access-Control-Allow-Origin'] = '*';
          //   fetchConfig.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
          //   fetchConfig.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
          //   fetchConfig.headers['Access-Control-Allow-Credentials'] = true;
          // }
          if (config.data !== undefined && config.data !== null) {
              if (config.data instanceof FormData) {
                  fetchConfig.body = config.data;
                  // fetchConfig.headers['Content-Type'] = undefined;
                  fetchConfig.headers['Accept'] = '*/*';
              }
              else {
                  fetchConfig.body = config.data instanceof Object ? JSON.stringify(config.data) : config.data;
                  fetchConfig.headers['Accept'] = 'application/json, text/plain, */*';
                  fetchConfig.headers['Content-Type'] = 'application/json';
                  // XSRF-TOKEN handling
                  var xsrfToken = this.getCookie('XSRF-TOKEN');
                  if (xsrfToken) {
                      fetchConfig.headers['X-XSRF-TOKEN'] = xsrfToken;
                  }
              }
          }
          // Add or overwrite any headers that were passed in
          fetchConfig.headers = tslib_1.__assign(tslib_1.__assign({}, fetchConfig.headers), (config.headers ? config.headers : {}));
          // Clean up any undefined or null values from the object if explicitly set
          for (var _i = 0, _a = Object.entries(fetchConfig.headers); _i < _a.length; _i++) {
              var _b = _a[_i], key = _b[0], value = _b[1];
              if (value === undefined || value === null) {
                  delete fetchConfig.headers[key];
              }
          }
          return fetch(url, fetchConfig).then(function (resp) {
              if (_this.responseInterceptor) {
                  return _this.responseInterceptor(resp);
              }
              return resp;
          }).then(function (resp) {
              var _a, _b;
              if (!resp.ok) {
                  if ((_a = resp.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
                      return resp.json().then(function (data) {
                          // Extend response to include data
                          return Promise.reject(Object.assign(resp, { data: data }));
                      });
                  }
                  if ((_b = resp.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('text/plain')) {
                      return resp.text().then(function (data) {
                          // Extend response to include data
                          return Promise.reject(Object.assign(resp, { data: data }));
                      });
                  }
                  return Promise.reject(Object.assign(resp, { data: null }));
              }
              if (resp.status === 204) {
                  return Promise.resolve(Object.assign(resp, { data: null }));
              }
              if (fetchConfig.method === 'HEAD') {
                  return Promise.resolve(Object.assign(resp, { data: null }));
              }
              var contentType = resp.headers.get('Content-Type');
              if (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')) {
                  return resp.json().then(function (data) {
                      // Extend response to include data
                      return Object.assign(resp, { data: data });
                  })
                      .catch(function (e) {
                      console.warn('HTTP: Failed to parse JSON response', e);
                      return Object.assign(resp, { data: null });
                  });
              }
              if ((contentType === null || contentType === void 0 ? void 0 : contentType.includes('text/plain')) || config.responseType === 'text') {
                  return resp.text().then(function (data) {
                      // Extend response to include data
                      return Object.assign(resp, { data: data });
                  });
              }
              return Promise.resolve(Object.assign(resp));
          });
      };
      Http.formatUrl = function (config) {
          var url = config.url;
          if (config.params) {
              if (url.includes('?')) {
                  url += '&';
              }
              else {
                  url += '?';
              }
              url += Http.getQueryString(config.params);
          }
          return url;
      };
      // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
      Http.getQueryString = function (params) {
          return Object.keys(params).map(function (k) {
              var param = params[k];
              if (Array.isArray(param)) {
                  return param
                      .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
                      .join('&');
              }
              return encodeURIComponent(k) + "=" + encodeURIComponent(param);
          }).join('&');
      };
      Http.prototype.request = function (config) {
          var _this = this;
          if (config === void 0) { config = {}; }
          if (config.cache === true) {
              return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
                  return _this.fetchJsonResponse(config);
              });
          }
          if (config.cache === 'refresh') {
              return this.config.cache.refresh(Http.formatUrl(config), function () {
                  return _this.fetchJsonResponse(config);
              });
          }
          return this.fetchJsonResponse(config);
      };
      Http.prototype.serviceRequest = function (serviceName, path, config) {
          var _this = this;
          if (config === void 0) { config = {}; }
          return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
              config.url = url;
              return _this.request(config);
          });
      };
      //
      // Shortcut methods
      //
      Http.prototype.get = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'GET';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.post = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'POST';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.put = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'PUT';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.patch = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'PATCH';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.delete = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'DELETE';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.head = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'HEAD';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.fetch = function (url, config) {
          if (config === void 0) { config = {}; }
          config.url = url;
          return this.fetchJsonResponse(config);
      };
      return Http;
  }());
  exports.default = Http;

  });

  var Preferences_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Http_1$1 = tslib_1.__importDefault(Http_1);
  var DEFAULT_CONFIG = {
      http: new Http_1$1.default(),
  };
  var Preferences = /** @class */ (function () {
      function Preferences(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
      }
      Preferences.prototype.get = function (path, cache) {
          if (path === void 0) { path = null; }
          if (cache === void 0) { cache = true; }
          var reqPath = 'preferences';
          if (path) {
              reqPath += '/' + path;
          }
          return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.update = function (prefs) {
          return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.patch = function (path, prefs) {
          return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.delete = function (path) {
          return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.deleteAll = function () {
          return this.config.http.delete('portal_service', 'preferences', { version: 2 });
      };
      return Preferences;
  }());
  exports.default = Preferences;

  });

  var Locale_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var Locale = /** @class */ (function () {
      function Locale() {
          this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
      }
      Locale.prototype.getCookieValue = function (cookieName) {
          var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
          if (match) {
              return decodeURIComponent(match[2]);
          }
          return null;
      };
      Locale.prototype.getBestFit = function () {
          var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
          if (cookie && cookie.locale) {
              return cookie.locale.split('-')[0];
          }
          return window.navigator.language.split('-')[0];
      };
      return Locale;
  }());
  exports.default = Locale;

  });

  createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.locale = exports.preferences = exports.http = exports.registry = exports.cache = void 0;

  var Cache_1$1 = tslib_1.__importDefault(Cache_1);
  var Registry_1$1 = tslib_1.__importDefault(Registry_1);
  var Http_1$1 = tslib_1.__importDefault(Http_1);
  var Preferences_1$1 = tslib_1.__importDefault(Preferences_1);
  var Locale_1$1 = tslib_1.__importDefault(Locale_1);
  // TODO: move into Registry and have it listen for blue ready
  function getRegistryHost() {
      var host = '';
      if (window.printos &&
          window.printos.blue &&
          window.printos.blue.ui &&
          window.printos.blue.ui.registry) {
          host = window.printos.blue.ui.registry.host;
      }
      return host;
  }
  exports.cache = new Cache_1$1.default();
  exports.registry = new Registry_1$1.default({
      cache: exports.cache,
      host: getRegistryHost(),
  });
  exports.http = new Http_1$1.default({
      cache: exports.cache,
      registry: exports.registry
  });
  exports.preferences = new Preferences_1$1.default({ http: exports.http });
  exports.locale = new Locale_1$1.default();
  exports.default = {
      cache: exports.cache,
      registry: exports.registry,
      http: exports.http,
      preferences: exports.preferences,
      locale: exports.locale,
  };

  });

  /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/spinner/src/Spinner.svelte generated by Svelte v3.38.2 */

  function create_else_block(ctx) {
  	let svg;
  	let rect;
  	let circle;
  	let animateTransform;

  	return {
  		c() {
  			svg = svg_element("svg");
  			rect = svg_element("rect");
  			circle = svg_element("circle");
  			animateTransform = svg_element("animateTransform");
  			attr(rect, "x", "0");
  			attr(rect, "y", "0");
  			attr(rect, "width", "100");
  			attr(rect, "height", "100");
  			attr(rect, "fill", "none");
  			attr(rect, "class", "bk");
  			attr(animateTransform, "attributeName", "transform");
  			attr(animateTransform, "type", "rotate");
  			attr(animateTransform, "values", "0 50 50;180 50 50;360 50 50;");
  			attr(animateTransform, "keyTimes", "0;0.5;1");
  			attr(animateTransform, "dur", "1s");
  			attr(animateTransform, "repeatCount", "indefinite");
  			attr(animateTransform, "begin", "0s");
  			attr(circle, "cx", "50");
  			attr(circle, "cy", "50");
  			attr(circle, "r", "42.5");
  			attr(circle, "stroke-dasharray", "173.57299411083608 93.46238144429634");
  			attr(circle, "stroke", "currentColor");
  			attr(circle, "fill", "none");
  			attr(circle, "stroke-width", "15");
  			attr(svg, "style", /*_style*/ ctx[0]);
  			attr(svg, "fill", "currentColor");
  			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
  			attr(svg, "viewBox", "0 0 100 100");
  			attr(svg, "preserveAspectRatio", "xMidYMid");
  			attr(svg, "class", "uil-ring");
  		},
  		m(target, anchor) {
  			insert(target, svg, anchor);
  			append(svg, rect);
  			append(svg, circle);
  			append(circle, animateTransform);
  		},
  		p(ctx, dirty) {
  			if (dirty & /*_style*/ 1) {
  				attr(svg, "style", /*_style*/ ctx[0]);
  			}
  		},
  		d(detaching) {
  			if (detaching) detach(svg);
  		}
  	};
  }

  // (2:2) {#if mode === 'printos'}
  function create_if_block$1(ctx) {
  	let svg;
  	let style;
  	let t;
  	let path0;
  	let path1;
  	let g;
  	let circle;

  	return {
  		c() {
  			svg = svg_element("svg");
  			style = svg_element("style");
  			t = text("@-webkit-keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}@keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}#el_ztyBp85wH *{-webkit-animation-duration: 3s;animation-duration: 3s;-webkit-animation-iteration-count: infinite;animation-iteration-count: infinite;-webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);animation-timing-function: cubic-bezier(0, 0, 1, 1);}#el_OK7WH8ppuY{fill: currentColor;}#el_pzIR5oVpeo{fill: currentColor;}#el_3R6WG92ED-{fill: none;stroke: currentColor;stroke-width: 5;}#el_3R6WG92ED-_9z4k3l2Lz{-webkit-animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;}");
  			path0 = svg_element("path");
  			path1 = svg_element("path");
  			g = svg_element("g");
  			circle = svg_element("circle");
  			attr(path0, "d", "M67,70V64.67l-3.53-.91a14.62,14.62,0,0,0-1.41-3.41L64,57.25l-3.73-3.82-3.13,1.91a21,21,0,0,0-3.43-1.5l-.91-3.51H47.33l-.91,3.51A13,13,0,0,0,43,55.24l-3.13-1.91-3.73,3.82L38,60.25a17.89,17.89,0,0,0-1.51,3.41L33,64.57V70l3.53.91a14.62,14.62,0,0,0,1.41,3.41L36,77.4l3.73,3.82,3.13-1.91a21,21,0,0,0,3.43,1.5l.91,3.52h5.44l.91-3.52A13,13,0,0,0,57,79.41l3.13,1.91L64,77.61,62.06,74.5a17.89,17.89,0,0,0,1.51-3.41ZM49.85,76.7a9.48,9.48,0,1,1,9.58-9.43A9.47,9.47,0,0,1,49.85,76.7Z");
  			attr(path0, "id", "el_OK7WH8ppuY");
  			attr(path1, "d", "M92.5,39.38h0a14,14,0,0,0-3.3-.91A19.08,19.08,0,0,0,78,24.77a18.87,18.87,0,0,0-7.6-1.6,20.32,20.32,0,0,0-5.5.8A24.09,24.09,0,0,0,51.7,9.67a24.54,24.54,0,0,0-9.5-2,24.37,24.37,0,0,0-22,14.4A19.84,19.84,0,0,0,18.9,26h-.2A18.34,18.34,0,0,0,2.1,36.67a17.78,17.78,0,0,0,9.3,23.5,18.62,18.62,0,0,0,6.9,1.5h.2c.3-1.6.7-3.1,1.1-4.6H18.5A12.61,12.61,0,0,1,13.2,56a13.33,13.33,0,0,1-8-12.09,14,14,0,0,1,1.1-5.3,13.37,13.37,0,0,1,12.2-8,10.87,10.87,0,0,1,1.8.1l2.3.3.3-2.3a15.65,15.65,0,0,1,1.4-4.8,19.07,19.07,0,0,1,17.8-11.5A19.34,19.34,0,0,1,49.8,14,19.61,19.61,0,0,1,61,27.48l.6,2.8L64.1,29a14.24,14.24,0,0,1,6.1-1.3,15.07,15.07,0,0,1,5.8,1.2,14.62,14.62,0,0,1,8.8,12l.2,2.3L87.3,43h.6a8.87,8.87,0,0,1,2.7.5,7,7,0,0,1,4.2,6.41,7.43,7.43,0,0,1-6.2,7.2h-7a39,39,0,0,1,1.2,4.6h6.1a11.75,11.75,0,0,0,9.5-7.1,12.7,12.7,0,0,0,1-4.6A11.14,11.14,0,0,0,92.5,39.38Z");
  			attr(path1, "id", "el_pzIR5oVpeo");
  			attr(circle, "cx", "50");
  			attr(circle, "cy", "67.33");
  			attr(circle, "r", "25");
  			attr(circle, "stroke-dasharray", "55");
  			attr(circle, "id", "el_3R6WG92ED-");
  			attr(g, "id", "el_3R6WG92ED-_9z4k3l2Lz");
  			attr(g, "data-animator-group", "true");
  			attr(g, "data-animator-type", "1");
  			attr(svg, "style", /*_style*/ ctx[0]);
  			attr(svg, "id", "el_ztyBp85wH");
  			attr(svg, "data-name", "Layer 1");
  			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
  			attr(svg, "viewBox", "0 0 100 100");
  		},
  		m(target, anchor) {
  			insert(target, svg, anchor);
  			append(svg, style);
  			append(style, t);
  			append(svg, path0);
  			append(svg, path1);
  			append(svg, g);
  			append(g, circle);
  		},
  		p(ctx, dirty) {
  			if (dirty & /*_style*/ 1) {
  				attr(svg, "style", /*_style*/ ctx[0]);
  			}
  		},
  		d(detaching) {
  			if (detaching) detach(svg);
  		}
  	};
  }

  function create_fragment$1(ctx) {
  	let div;

  	function select_block_type(ctx, dirty) {
  		if (/*mode*/ ctx[1] === "printos") return create_if_block$1;
  		return create_else_block;
  	}

  	let current_block_type = select_block_type(ctx);
  	let if_block = current_block_type(ctx);

  	return {
  		c() {
  			div = element("div");
  			if_block.c();
  			attr(div, "class", "pros-spinner");
  		},
  		m(target, anchor) {
  			insert(target, div, anchor);
  			if_block.m(div, null);
  		},
  		p(ctx, [dirty]) {
  			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
  				if_block.p(ctx, dirty);
  			} else {
  				if_block.d(1);
  				if_block = current_block_type(ctx);

  				if (if_block) {
  					if_block.c();
  					if_block.m(div, null);
  				}
  			}
  		},
  		i: noop,
  		o: noop,
  		d(detaching) {
  			if (detaching) detach(div);
  			if_block.d();
  		}
  	};
  }

  function instance$1($$self, $$props, $$invalidate) {
  	let { diameter = null } = $$props;
  	let { mode = null } = $$props;
  	let { color = null } = $$props;
  	let { _style = "" } = $$props;
  	let { _diameter = null } = $$props;

  	$$self.$$set = $$props => {
  		if ("diameter" in $$props) $$invalidate(3, diameter = $$props.diameter);
  		if ("mode" in $$props) $$invalidate(1, mode = $$props.mode);
  		if ("color" in $$props) $$invalidate(4, color = $$props.color);
  		if ("_style" in $$props) $$invalidate(0, _style = $$props._style);
  		if ("_diameter" in $$props) $$invalidate(2, _diameter = $$props._diameter);
  	};

  	$$self.$$.update = () => {
  		if ($$self.$$.dirty & /*diameter, _diameter, mode, _style, color*/ 31) {
  			{
  				$$invalidate(2, _diameter = diameter ? Number(diameter) : null);

  				if (!_diameter) {
  					$$invalidate(2, _diameter = mode === "printos" ? 200 : 50);
  				}

  				$$invalidate(0, _style = `height:${_diameter}px;width:${_diameter}px;`);
  				$$invalidate(0, _style += color ? `color:${color};` : `color:#0096d6;`);
  			}
  		}
  	};

  	return [_style, mode, _diameter, diameter, color];
  }

  class Spinner extends SvelteComponent {
  	constructor(options) {
  		super();

  		init(this, options, instance$1, create_fragment$1, safe_not_equal, {
  			diameter: 3,
  			mode: 1,
  			color: 4,
  			_style: 0,
  			_diameter: 2
  		});
  	}
  }

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  // do not edit .js files directly - edit src/index.jst



  var fastDeepEqual = function equal(a, b) {
    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
      if (a.constructor !== b.constructor) return false;

      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;)
          if (!equal(a[i], b[i])) return false;
        return true;
      }



      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;

      for (i = length; i-- !== 0;)
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

      for (i = length; i-- !== 0;) {
        var key = keys[i];

        if (!equal(a[key], b[key])) return false;
      }

      return true;
    }

    // true if both NaN, false otherwise
    return a!==a && b!==b;
  };

  /**
   * Copyright 2019 Google LLC. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at.
   *
   *      Http://www.apache.org/licenses/LICENSE-2.0.
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  const DEFAULT_ID = "__googleMapsScriptId";
  /**
   * The status of the [[Loader]].
   */
  var LoaderStatus;
  (function (LoaderStatus) {
      LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
      LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
      LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
      LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
  })(LoaderStatus || (LoaderStatus = {}));
  /**
   * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
   * dynamically using
   * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
   * It works by dynamically creating and appending a script node to the the
   * document head and wrapping the callback function so as to return a promise.
   *
   * ```
   * const loader = new Loader({
   *   apiKey: "",
   *   version: "weekly",
   *   libraries: ["places"]
   * });
   *
   * loader.load().then((google) => {
   *   const map = new google.maps.Map(...)
   * })
   * ```
   */
  class Loader {
      /**
       * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
       * using this library, instead the defaults are set by the Google Maps
       * JavaScript API server.
       *
       * ```
       * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
       * ```
       */
      constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
          this.callbacks = [];
          this.done = false;
          this.loading = false;
          this.errors = [];
          this.apiKey = apiKey;
          this.authReferrerPolicy = authReferrerPolicy;
          this.channel = channel;
          this.client = client;
          this.id = id || DEFAULT_ID; // Do not allow empty string
          this.language = language;
          this.libraries = libraries;
          this.mapIds = mapIds;
          this.nonce = nonce;
          this.region = region;
          this.retries = retries;
          this.url = url;
          this.version = version;
          if (Loader.instance) {
              if (!fastDeepEqual(this.options, Loader.instance.options)) {
                  throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
              }
              return Loader.instance;
          }
          Loader.instance = this;
      }
      get options() {
          return {
              version: this.version,
              apiKey: this.apiKey,
              channel: this.channel,
              client: this.client,
              id: this.id,
              libraries: this.libraries,
              language: this.language,
              region: this.region,
              mapIds: this.mapIds,
              nonce: this.nonce,
              url: this.url,
              authReferrerPolicy: this.authReferrerPolicy,
          };
      }
      get status() {
          if (this.errors.length) {
              return LoaderStatus.FAILURE;
          }
          if (this.done) {
              return LoaderStatus.SUCCESS;
          }
          if (this.loading) {
              return LoaderStatus.LOADING;
          }
          return LoaderStatus.INITIALIZED;
      }
      get failed() {
          return this.done && !this.loading && this.errors.length >= this.retries + 1;
      }
      /**
       * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
       *
       * @ignore
       * @deprecated
       */
      createUrl() {
          let url = this.url;
          url += `?callback=__googleMapsCallback`;
          if (this.apiKey) {
              url += `&key=${this.apiKey}`;
          }
          if (this.channel) {
              url += `&channel=${this.channel}`;
          }
          if (this.client) {
              url += `&client=${this.client}`;
          }
          if (this.libraries.length > 0) {
              url += `&libraries=${this.libraries.join(",")}`;
          }
          if (this.language) {
              url += `&language=${this.language}`;
          }
          if (this.region) {
              url += `&region=${this.region}`;
          }
          if (this.version) {
              url += `&v=${this.version}`;
          }
          if (this.mapIds) {
              url += `&map_ids=${this.mapIds.join(",")}`;
          }
          if (this.authReferrerPolicy) {
              url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
          }
          return url;
      }
      deleteScript() {
          const script = document.getElementById(this.id);
          if (script) {
              script.remove();
          }
      }
      /**
       * Load the Google Maps JavaScript API script and return a Promise.
       * @deprecated, use importLibrary() instead.
       */
      load() {
          return this.loadPromise();
      }
      /**
       * Load the Google Maps JavaScript API script and return a Promise.
       *
       * @ignore
       * @deprecated, use importLibrary() instead.
       */
      loadPromise() {
          return new Promise((resolve, reject) => {
              this.loadCallback((err) => {
                  if (!err) {
                      resolve(window.google);
                  }
                  else {
                      reject(err.error);
                  }
              });
          });
      }
      importLibrary(name) {
          this.execute();
          return google.maps.importLibrary(name);
      }
      /**
       * Load the Google Maps JavaScript API script with a callback.
       * @deprecated, use importLibrary() instead.
       */
      loadCallback(fn) {
          this.callbacks.push(fn);
          this.execute();
      }
      /**
       * Set the script on document.
       */
      setScript() {
          var _a, _b;
          if (document.getElementById(this.id)) {
              // TODO wrap onerror callback for cases where the script was loaded elsewhere
              this.callback();
              return;
          }
          const params = {
              key: this.apiKey,
              channel: this.channel,
              client: this.client,
              libraries: this.libraries.length && this.libraries,
              v: this.version,
              mapIds: this.mapIds,
              language: this.language,
              region: this.region,
              authReferrerPolicy: this.authReferrerPolicy,
          };
          // keep the URL minimal:
          Object.keys(params).forEach(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (key) => !params[key] && delete params[key]);
          if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) {
              // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
              // which also sets the base url, the id, and the nonce
              /* eslint-disable */
              ((g) => {
                  // @ts-ignore
                  let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                  // @ts-ignore
                  b = b[c] || (b[c] = {});
                  // @ts-ignore
                  const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = () => 
                  // @ts-ignore
                  h || (h = new Promise((f, n) => __awaiter(this, void 0, void 0, function* () {
                      var _a;
                      yield (a = m.createElement("script"));
                      a.id = this.id;
                      e.set("libraries", [...r] + "");
                      // @ts-ignore
                      for (k in g)
                          e.set(k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()), g[k]);
                      e.set("callback", c + ".maps." + q);
                      a.src = this.url + `?` + e;
                      d[q] = f;
                      a.onerror = () => (h = n(Error(p + " could not load.")));
                      // @ts-ignore
                      a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                      m.head.append(a);
                  })));
                  // @ts-ignore
                  d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
              })(params);
              /* eslint-enable */
          }
          // While most libraries populate the global namespace when loaded via bootstrap params,
          // this is not the case for "marker" when used with the inline bootstrap loader
          // (and maybe others in the future). So ensure there is an importLibrary for each:
          const libraryPromises = this.libraries.map((library) => this.importLibrary(library));
          // ensure at least one library, to kick off loading...
          if (!libraryPromises.length) {
              libraryPromises.push(this.importLibrary("core"));
          }
          Promise.all(libraryPromises).then(() => this.callback(), (error) => {
              const event = new ErrorEvent("error", { error }); // for backwards compat
              this.loadErrorCallback(event);
          });
      }
      /**
       * Reset the loader state.
       */
      reset() {
          this.deleteScript();
          this.done = false;
          this.loading = false;
          this.errors = [];
          this.onerrorEvent = null;
      }
      resetIfRetryingFailed() {
          if (this.failed) {
              this.reset();
          }
      }
      loadErrorCallback(e) {
          this.errors.push(e);
          if (this.errors.length <= this.retries) {
              const delay = this.errors.length * Math.pow(2, this.errors.length);
              console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
              setTimeout(() => {
                  this.deleteScript();
                  this.setScript();
              }, delay);
          }
          else {
              this.onerrorEvent = e;
              this.callback();
          }
      }
      callback() {
          this.done = true;
          this.loading = false;
          this.callbacks.forEach((cb) => {
              cb(this.onerrorEvent);
          });
          this.callbacks = [];
      }
      execute() {
          this.resetIfRetryingFailed();
          if (this.done) {
              this.callback();
          }
          else {
              // short circuit and warn if google.maps is already loaded
              if (window.google && window.google.maps && window.google.maps.version) {
                  console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                      "This may result in undesirable behavior as options and script parameters may not match.");
                  this.callback();
                  return;
              }
              if (this.loading) ;
              else {
                  this.loading = true;
                  this.setScript();
              }
          }
      }
  }

  function add_css() {
    var style = element("style");
    style.id = "svelte-qyfdwa-style";
    style.textContent = ".pros-map-wrapper.svelte-qyfdwa.svelte-qyfdwa{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.pros-map-wrapper.svelte-qyfdwa .pros-map-container.svelte-qyfdwa{flex:1;width:100%}.pros-map-wrapper.svelte-qyfdwa .pros-map-container.loading.svelte-qyfdwa{display:none}";
    append(document.head, style);
  }

  // (2:2) {#if loading}
  function create_if_block_1(ctx) {
    var spinner;
    var current;
    spinner = new Spinner({
      props: {
        diameter: "24"
      }
    });
    return {
      c: function c() {
        create_component(spinner.$$.fragment);
      },
      m: function m(target, anchor) {
        mount_component(spinner, target, anchor);
        current = true;
      },
      i: function i(local) {
        if (current) return;
        transition_in(spinner.$$.fragment, local);
        current = true;
      },
      o: function o(local) {
        transition_out(spinner.$$.fragment, local);
        current = false;
      },
      d: function d(detaching) {
        destroy_component(spinner, detaching);
      }
    };
  }

  // (5:2) {#if error}
  function create_if_block(ctx) {
    var t;
    return {
      c: function c() {
        t = text("Maps key not resolved in config or from PrintOS Header API");
      },
      m: function m(target, anchor) {
        insert(target, t, anchor);
      },
      d: function d(detaching) {
        if (detaching) detach(t);
      }
    };
  }
  function create_fragment(ctx) {
    var div1;
    var t0;
    var t1;
    var div0;
    var current;
    var if_block0 = /*loading*/ctx[1] && create_if_block_1();
    var if_block1 = /*error*/ctx[2] && create_if_block();
    return {
      c: function c() {
        div1 = element("div");
        if (if_block0) if_block0.c();
        t0 = space();
        if (if_block1) if_block1.c();
        t1 = space();
        div0 = element("div");
        attr(div0, "class", "pros-map-container svelte-qyfdwa");
        toggle_class(div0, "loading", /*loading*/ctx[1] || /*error*/ctx[2]);
        attr(div1, "class", "pros-map-wrapper svelte-qyfdwa");
      },
      m: function m(target, anchor) {
        insert(target, div1, anchor);
        if (if_block0) if_block0.m(div1, null);
        append(div1, t0);
        if (if_block1) if_block1.m(div1, null);
        append(div1, t1);
        append(div1, div0);
        /*div0_binding*/
        ctx[14](div0);
        current = true;
      },
      p: function p(ctx, _ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];
        if (/*loading*/ctx[1]) {
          if (if_block0) {
            if (dirty & /*loading*/2) {
              transition_in(if_block0, 1);
            }
          } else {
            if_block0 = create_if_block_1();
            if_block0.c();
            transition_in(if_block0, 1);
            if_block0.m(div1, t0);
          }
        } else if (if_block0) {
          group_outros();
          transition_out(if_block0, 1, 1, function () {
            if_block0 = null;
          });
          check_outros();
        }
        if (/*error*/ctx[2]) {
          if (if_block1) ; else {
            if_block1 = create_if_block();
            if_block1.c();
            if_block1.m(div1, t1);
          }
        } else if (if_block1) {
          if_block1.d(1);
          if_block1 = null;
        }
        if (dirty & /*loading, error*/6) {
          toggle_class(div0, "loading", /*loading*/ctx[1] || /*error*/ctx[2]);
        }
      },
      i: function i(local) {
        if (current) return;
        transition_in(if_block0);
        current = true;
      },
      o: function o(local) {
        transition_out(if_block0);
        current = false;
      },
      d: function d(detaching) {
        if (detaching) detach(div1);
        if (if_block0) if_block0.d();
        if (if_block1) if_block1.d();
        /*div0_binding*/
        ctx[14](null);
      }
    };
  }
  function getLocation(place) {
    return {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    };
  }
  function hasValue(test) {
    return test !== undefined && test !== null;
  }
  function instance($$self, $$props, $$invalidate) {
    createEventDispatcher();
    var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "auto" : _$$props$theme; // Color Theme (auto/dark/light)
    var _$$props$mode = $$props.mode,
      mode = _$$props$mode === void 0 ? "default" : _$$props$mode; // default/form
    var _$$props$className = $$props.className,
      className = _$$props$className === void 0 ? "" : _$$props$className; // Class name
    var _$$props$options = $$props.options,
      options = _$$props$options === void 0 ? {} : _$$props$options;
    var _theme = $$props._theme;
    var _lastTheme = $$props._lastTheme;
    var _className = $$props._className;
    var _mapElement = $$props._mapElement;
    var loader;
    var map = $$props.map;
    var placesService = $$props.placesService;
    var geoCoderService = $$props.geoCoderService;
    var currentMarkers = [];
    var loading = true;
    var error = false;
    onMount(function () {
      var mapsKey = options && options.mapsKey ? options.mapsKey : window.$printos.client.v1.getRegistryValue("mapsKey");
      if (mapsKey) {
        loader = new Loader({
          apiKey: mapsKey,
          version: "weekly"
        });
        $$invalidate(8, _className = hasValue(className) ? className : "");
        initMap()["finally"](function () {
          $$invalidate(1, loading = false);
        });
      } else {
        $$invalidate(2, error = true);
        $$invalidate(1, loading = false);
      }
    });
    function initMap() {
      return loadMap().then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateMarkers(options.markers ? options.markers : []);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    }
    function loadMap() {
      return new Promise(function (resolve, reject) {
        loader.load().then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var _yield$google$maps$im, Map, mapOptions;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return google.maps.importLibrary("maps");
              case 2:
                _yield$google$maps$im = _context2.sent;
                Map = _yield$google$maps$im.Map;
                // const { Place } = await google.maps.importLibrary('places');
                mapOptions = {
                  center: {
                    lat: 0,
                    lng: 0
                  },
                  zoom: options.zoom ? options.zoom : 0,
                  mapId: options.mapId ? options.mapId : "Map".concat(Math.floor(Math.random() * 1000))
                };
                if (options.mapOptions) {
                  mapOptions = _objectSpread2(_objectSpread2({}, mapOptions), options.mapOptions);
                }
                $$invalidate(9, map = new Map(_mapElement, mapOptions));
                $$invalidate(10, placesService = new google.maps.places.PlacesService(map));
                $$invalidate(11, geoCoderService = new google.maps.Geocoder());
                if (options.callbacks) {
                  if (options.callbacks.click) {
                    window.google.maps.event.addListener(map, "click", handleClick);
                  }
                }
                $$invalidate(5, options.api = {
                  updateMarkers: updateMarkers,
                  map: map
                }, options);
                resolve();
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })));
      });
    }
    function handleClick(event) {
      geoCoderService.geocode({
        "latLng": event.latLng
      }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          options.callbacks.click(results[0]);
        }
      });
    }
    function updateMarkers(_x) {
      return _updateMarkers.apply(this, arguments);
    }
    function _updateMarkers() {
      _updateMarkers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(markers) {
        var _yield$google$maps$im2, AdvancedMarkerElement, promises;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return google.maps.importLibrary("marker");
            case 2:
              _yield$google$maps$im2 = _context3.sent;
              AdvancedMarkerElement = _yield$google$maps$im2.AdvancedMarkerElement;
              if (currentMarkers) {
                currentMarkers.forEach(function (m) {
                  m.setMap(null);
                });
                currentMarkers.splice(0, markers.length);
              }
              promises = [];
              markers.forEach(function (marker) {
                switch (marker.type) {
                  case "position":
                    //console.log('marker from position', marker.position);
                    break;
                  case "place":
                    //console.log('marker from place', place);
                    marker.position = getLocation(marker.place);
                    if (!marker.title) {
                      marker.title = marker.place.formatted_address;
                    }
                    break;
                  case "printos_address":
                    promises.push(getPlaceFromAddressAsync(marker.address).then(function (place) {
                      //console.log('marker from printos address', place);
                      marker.position = getLocation(place);
                      if (!marker.title) {
                        marker.title = place.formatted_address;
                      }
                    })["catch"](function () {
                      console.log("Map - Failed to resolve marker", marker.address);
                      return Promise.resolve();
                    }));
                    break;
                  case "address_string":
                    promises.push(getPlaceFromStringAsync(marker.address).then(function (place) {
                      //console.log('marker from address', place);
                      if (!place) {
                        return;
                      }
                      marker.position = getLocation(place);
                      if (!marker.title) {
                        marker.title = place.formatted_address;
                      }
                    })["catch"](function () {
                      console.log("Map - Failed to resolve marker", marker.address);
                      return Promise.resolve();
                    }));
                    break;
                }
              });
              currentMarkers = [];
              return _context3.abrupt("return", Promise.all(promises).then(function () {
                markers.forEach(function (marker) {
                  var markerOptions = {
                    map: map,
                    position: marker.position
                  };
                  if (marker.markerOptions) {
                    markerOptions = _objectSpread2(_objectSpread2({}, markerOptions), marker.markerOptions);
                  }
                  if (marker.title) {
                    markerOptions.title = marker.title;
                  }
                  if (marker.content) {
                    markerOptions.content = marker.content;
                  }
                  marker.marker = new AdvancedMarkerElement(markerOptions);
                  if (marker.click) {
                    marker.marker.addListener("click", marker.click);
                  }
                  currentMarkers.push(marker.marker);
                });
                if (!hasValue(options.zoom) && currentMarkers.length === 1) {
                  map.setCenter(currentMarkers[0].position);
                  map.setZoom(8);
                }
              }));
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _updateMarkers.apply(this, arguments);
    }
    function getPlaceFromStringAsync(query) {
      var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        placesService.findPlaceFromQuery({
          query: query,
          fields: ["name", "geometry", "place_id", "formatted_address"]
        }, function (results, status) {
          if (!results || results.length === 0) {
            resolve(null);
            return;
          }
          var result = results[0];
          if (details) {
            placesService.getDetails({
              placeId: result.place_id,
              fields: ["address_components"]
            }, function (details, status) {
              resolve(_objectSpread2(_objectSpread2({}, result), details));
            });
          } else {
            resolve(result);
          }
        });
      });
    }
    function getPlaceFromAddressAsync(address) {
      var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var query = "";
      if (address.addressLine1) {
        query += "".concat(address.addressLine1, " ");
      }
      if (address.addressLine2) {
        query += "".concat(address.addressLine2, " ");
      }
      if (address.locality) {
        query += "".concat(address.locality, " ");
      }
      if (address.region) {
        query += "".concat(address.region, " ");
      }
      if (address.postalCode) {
        query += "".concat(address.postalCode, " ");
      }
      if (address.country) {
        query += "".concat(address.country, " ");
      }
      return getPlaceFromStringAsync(query, details);
    }
    beforeUpdate(function () {
      $$invalidate(3, theme = hasValue(theme) ? theme : "light");
      $$invalidate(4, mode = hasValue(mode) ? mode : "icon");
      if (theme !== _lastTheme) {
        $$invalidate(7, _lastTheme = theme);
        if (theme === "auto") {
          var themeAttribute = window.document.body.getAttribute("pos--theme");
          $$invalidate(6, _theme = themeAttribute ? themeAttribute : "light");
          window.removeEventListener("posh-theme-changed", handleThemeChanged);
          window.addEventListener("posh-theme-changed", handleThemeChanged);
        } else {
          $$invalidate(6, _theme = theme);
        }
      }
    });
    onDestroy(function () {
      window.removeEventListener("posh-theme-changed", handleThemeChanged);
    });
    function handleThemeChanged(event) {
      if (theme === "auto") {
        $$invalidate(6, _theme = event.detail.theme);
      }
    }
    function div0_binding($$value) {
      binding_callbacks[$$value ? "unshift" : "push"](function () {
        _mapElement = $$value;
        $$invalidate(0, _mapElement);
      });
    }
    $$self.$$set = function ($$props) {
      if ("theme" in $$props) $$invalidate(3, theme = $$props.theme);
      if ("mode" in $$props) $$invalidate(4, mode = $$props.mode);
      if ("className" in $$props) $$invalidate(12, className = $$props.className);
      if ("options" in $$props) $$invalidate(5, options = $$props.options);
      if ("_theme" in $$props) $$invalidate(6, _theme = $$props._theme);
      if ("_lastTheme" in $$props) $$invalidate(7, _lastTheme = $$props._lastTheme);
      if ("_className" in $$props) $$invalidate(8, _className = $$props._className);
      if ("_mapElement" in $$props) $$invalidate(0, _mapElement = $$props._mapElement);
      if ("map" in $$props) $$invalidate(9, map = $$props.map);
      if ("placesService" in $$props) $$invalidate(10, placesService = $$props.placesService);
      if ("geoCoderService" in $$props) $$invalidate(11, geoCoderService = $$props.geoCoderService);
    };
    return [_mapElement, loading, error, theme, mode, options, _theme, _lastTheme, _className, map, placesService, geoCoderService, className, hasValue, div0_binding];
  }
  var Map$1 = /*#__PURE__*/function (_SvelteComponent) {
    function Map(options) {
      var _this;
      _classCallCheck(this, Map);
      _this = _callSuper(this, Map);
      if (!document.getElementById("svelte-qyfdwa-style")) add_css();
      init(_this, options, instance, create_fragment, safe_not_equal, {
        theme: 3,
        mode: 4,
        className: 12,
        options: 5,
        _theme: 6,
        _lastTheme: 7,
        _className: 8,
        _mapElement: 0,
        map: 9,
        placesService: 10,
        geoCoderService: 11,
        hasValue: 13
      });
      return _this;
    }
    _inherits(Map, _SvelteComponent);
    return _createClass(Map, [{
      key: "hasValue",
      get: function get() {
        return hasValue;
      }
    }]);
  }(SvelteComponent);

  exports.Map = Map$1;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
